import { QRCodeSVG } from "qrcode.react";
import { getIsValidString } from "@/utils/functions";

export interface PixImage {
  image: string;
  type: string;
  width: number;
}

interface PixQrCodeProps {
  pixCode: string;
  pixImage?: PixImage | null;
  size?: number;
  className?: string;
}

export default function PixQrCode({
  pixCode,
  pixImage,
  size = 200,
  className = "",
}: PixQrCodeProps) {
  if (pixImage?.image) {
    return (
      <div className={`flex justify-center ${className}`}>
        <img
          src={`data:${pixImage.type};base64,${pixImage.image}`}
          alt="QR Code Pix"
          width={size}
          height={size}
          className="object-contain"
        />
      </div>
    );
  }

  if (!getIsValidString(pixCode)) {
    return null;
  }

  return (
    <div className={`flex justify-center ${className}`}>
      <QRCodeSVG
        value={pixCode}
        size={size}
        level="M"
        bgColor="#FFFFFF"
        fgColor="#000000"
      />
    </div>
  );
}
